import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "../assets/css/explore.css";
import About from "../pages/About/About";
import Community from "../pages/Community/Community";
import Newsletter from "../pages/Contact/Newsletter";
import Explore from "../pages/Explore/Explore";
import FaqPage from "../pages/Faqs/FaqPage";
import Home from "../pages/Home/Home";
import RoadMap from "../pages/RoadMap/RoadMap";
import Feature from "../pages/Feature/Feature";

// Pages Import

const PublicRoutes = () => {
	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/explore" element={<Explore />} />
					<Route path="/roadmap" element={<RoadMap />} />
					<Route path="/faqs" element={<FaqPage />} />
					<Route path="/community" element={<Community />} />
					<Route path="/contact" element={<Newsletter />} />
					<Route path="/feature" element={<Feature />} />
				</Routes>
			</BrowserRouter>
		</>
	);
};

export default PublicRoutes;
